import Box from '@mui/material/Box';
import './MenuWrapper.scss';

const MenuWrapper = ({children}: {children: React.ReactElement}) => {
  return (
    <Box className="prizmdoc-menu-wrapper" gap={1}>
      {children}
    </Box>
  );
};

export default MenuWrapper;
